import React, { useState, useEffect } from "react";
import BaseModal from "../../../components/ui/BaseModal";
import BaseDatePicker from "../../../components/ui/BaseDatePicker";
import BaseButton from "../../../components/ui/BaseButton";
import dayjs from "dayjs";
import { useMutation } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { showToast } from "../../../store/toast/toastSlice";
import { updateTimeLogs } from "../../../services/api/timeLog"; // <-- your new API
import { useUpdateWorkOrder } from "../../../hooks/useUpdateWorkOrder";
import TimeLogs from "../TabsCard/TimeLogs";

const EditTimeLogModal = ({ log, onClose,refetchworkOrderPaymentData }) => {
  const dispatch = useDispatch();
  const { updateWorkOrder } = useUpdateWorkOrder();

  const [form, setForm] = useState({
    checkInDate: null,
    checkInTime: null,
    checkOutDate: null,
    checkOutTime: null,
  });

  // PRE-FILL existing times
  useEffect(() => {
    if (log?.checkInTime) {
      const dt = dayjs(log.checkInTime);
      setForm((prev) => ({
        ...prev,
        checkInDate: dt.format("YYYY-MM-DD"),
        checkInTime: dt.format("HH:mm:ss"),
      }));
    }
    if (log?.checkOutTime) {
      const dt = dayjs(log.checkOutTime);
      setForm((prev) => ({
        ...prev,
        checkOutDate: dt.format("YYYY-MM-DD"),
        checkOutTime: dt.format("HH:mm:ss"),
      }));
    }
  }, [log]);

  const mutation = useMutation({
    mutationFn: updateTimeLogs,
  });

  const handleChange = (name, e) => {
    setForm((prev) => ({
      ...prev,
      [name]: e,
    }));
  };

  const handleSave = async () => {
    try {
      const formattedCheckIn =
        form.checkInDate && form.checkInTime
          ? `${form.checkInDate} ${form.checkInTime}`
          : null;

      const formattedCheckOut =
        form.checkOutDate && form.checkOutTime
          ? `${form.checkOutDate} ${form.checkOutTime}`
          : null;

      const payload = [
        {
          id: log.id,
          checkInTime: formattedCheckIn,
          checkOutTime: formattedCheckOut,
        },
      ];

      await mutation.mutateAsync(payload);

      dispatch(
        showToast({
          type: "success",
          message: "Time log updated successfully",
        })
      );

      updateWorkOrder();
    //   onUpdated?.();
      onClose();
    } catch (err) {
      dispatch(
        showToast({
          type: "error",
          message: err?.response?.data?.message || "Failed to update timelog",
        })
      );
    }
  };

  return (
    <BaseModal open={true} close={onClose} className="overflow-auto" style={{ width: "1000px" }}>
      <TimeLogs refetchworkOrderPaymentData={refetchworkOrderPaymentData}/>
    </BaseModal>
  );
};

export default EditTimeLogModal;
